import { $form, $view } from 'signals/global.signals';
import { getPortfolioFormData } from 'components/global/InvestorPortfolioForm/_helpers/investorPortfolio.utils';
import { createPortfolio, deletePortfolio, updatePortfolio } from 'api/portfolio.api';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { fetchAndSetPortfolioData } from 'components/views/InvestorPortfolioList/_helpers/investorPortfolioList.resolvers';
import displayError from 'utils/displayError';

export const handleSubmitCreatePortfolio = async () => {
  $view.update({ isModalLoading: true });
  try {
    const formData = getPortfolioFormData($form.value);
    await createPortfolio(formData);
    handleHideModal();
    await fetchAndSetPortfolioData();
  } catch (error) {
    displayError({
      message: 'Failed to create portfolio entry. Please try again.',
      title: 'Creation Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};

export const handleSubmitUpdatePortfolio = async () => {
  $view.update({ isModalLoading: true });
  try {
    const formData = getPortfolioFormData($form.value);
    await updatePortfolio($form.value.id, formData);
    handleHideModal();
    await fetchAndSetPortfolioData();
  } catch (error) {
    displayError({
      message: 'Failed to update portfolio entry. Please try again.',
      title: 'Update Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};

export const handleSubmitDeletePortfolio = async () => {
  $view.update({ isModalLoading: true });
  try {
    await deletePortfolio($form.value.id);
    handleHideModal();
    await fetchAndSetPortfolioData();
  } catch (error) {
    displayError({
      message: 'Failed to delete portfolio entry. Please try again.',
      title: 'Delete Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};
